(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jr-harley-range"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const initialize=root=>{if(!root)return;
 if(root._jrDestroy)root._jrDestroy();
 const cleanups=[];const on=(el,event,fn)=>{el.addEventListener(event,fn);cleanups.push(()=>el.removeEventListener(event,fn));};
 const reduced=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 root.querySelectorAll('.jr-harley-range__family').forEach(family=>{
  const track=family.querySelector('.jr-harley-range__track'),prev=family.querySelector('[data-prev]'),next=family.querySelector('[data-next]');if(!track||!prev||!next)return;
  prev.hidden=false;next.hidden=false;
  const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
  const move=dir=>{const card=track.querySelector('.jr-harley-range__card');if(card)track.scrollBy({left:dir*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap||0)),behavior:reduced()?'auto':'smooth'});};
  on(prev,'click',()=>move(-1));on(next,'click',()=>move(1));on(track,'scroll',update);on(track,'keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
  if('ResizeObserver'in window){const ro=new ResizeObserver(update);ro.observe(track);cleanups.push(()=>ro.disconnect());}else on(window,'resize',update);update();
 });
 const links=[...root.querySelectorAll('[data-family-link]')],families=[...root.querySelectorAll('.jr-harley-range__family')];
 const mark=target=>links.forEach(link=>{if(link.hash==='#'+target.id)link.setAttribute('aria-current','location');else link.removeAttribute('aria-current');});
 const nav=root.querySelector('.jr-harley-range__nav');
 const offset=()=>parseFloat(getComputedStyle(root).getPropertyValue('--jr-top'))+(nav?nav.offsetHeight:0)+20;
 links.forEach(link=>on(link,'click',e=>{const target=document.getElementById(link.hash.slice(1));if(!target)return;e.preventDefault();target.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'start'});mark(target);}));
 let frame;const updateActive=()=>{frame=null;let active=families[0];families.forEach(f=>{if(f.getBoundingClientRect().top<=offset())active=f;});if(active)mark(active);};
 const schedule=()=>{if(!frame)frame=requestAnimationFrame(updateActive);};on(window,'scroll',schedule);on(window,'resize',schedule);updateActive();cleanups.push(()=>cancelAnimationFrame(frame));
 const select=e=>{if(root.contains(e.target)){e.target.scrollIntoView({behavior:'auto',block:'start'});mark(e.target);}};on(document,'shopify:block:select',select);
 const unload=e=>{if(e.detail.sectionId===root.dataset.sectionId)root._jrDestroy();};on(document,'shopify:section:unload',unload);
 root._jrDestroy=()=>{cleanups.forEach(fn=>fn());delete root._jrDestroy;};
};
 document.querySelectorAll('.jr-harley-range').forEach(initialize);
 document.addEventListener('shopify:section:load',e=>{const root=e.target.querySelector('.jr-harley-range');if(root)initialize(root);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
